import type { CSSProperties, ReactNode } from 'react';

interface ColumnProps {
  /**
   * CSS Grid `grid-template-rows` value. Derived by SurfaceRenderer from
   * children's catalog category + per-child weight/height hints (see
   * `deriveTracks` in `../../components/surface/layout-template.ts`).
   */
  template?: string;
  align?: string;
  justify?: string;
  gap?: number;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export function ColumnView({
  template,
  align,
  justify,
  gap,
  className,
  style,
  children,
}: ColumnProps) {
  return (
    <div
      className={className}
      style={{
        // User-supplied style spreads FIRST so the grid-defining props
        // below cannot be overridden by an agent's accidental display: 'block'.
        ...style,
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)',
        gridTemplateRows: template && template.length > 0 ? template : 'auto',
        alignItems: align ?? 'stretch',
        justifyContent: justify ?? 'start',
        // Surplus min-height space falls below the last track instead of stretching `auto` rows.
        alignContent: 'start',
        gap: `${gap ?? 8}px`,
        width: '100%',
        minHeight: '100%',
      }}
    >
      {children}
    </div>
  );
}
